<template>
  <div v-if="unit" class="blog">
    <div class="BlogContent w margin">
      <img
        class="hiddenInDesktop"
        id="mobile_unitMainImage"
        :src="unit.image"
        :alt="unit.title"
      />
      <div class="blogContent__righbox">
        <div class="blogbox__title">
          <h3>{{ unit.title }}</h3>
          <div id="socialUnit">
            <a v-if="unit.instagram" :href="unit.instagram">
              <Instagram class="socialIcon" />
            </a>
            <a v-if="unit.whatsapp" :href="'https://wa.me/' + unit.whatsapp">
              <svg
                width="50px"
                height="50px"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16 31C23.732 31 30 24.732 30 17C30 9.26801 23.732 3 16 3C8.26801 3 2 9.26801 2 17C2 19.5109 2.661 21.8674 3.81847 23.905L2 31L9.31486 29.3038C11.3014 30.3854 13.5789 31 16 31ZM16 28.8462C22.5425 28.8462 27.8462 23.5425 27.8462 17C27.8462 10.4576 22.5425 5.15385 16 5.15385C9.45755 5.15385 4.15385 10.4576 4.15385 17C4.15385 19.5261 4.9445 21.8675 6.29184 23.7902L5.23077 27.7692L9.27993 26.7569C11.1894 28.0746 13.5046 28.8462 16 28.8462Z"
                  fill="#BFC8D0"
                />
                <path
                  d="M28 16C28 22.6274 22.6274 28 16 28C13.4722 28 11.1269 27.2184 9.19266 25.8837L5.09091 26.9091L6.16576 22.8784C4.80092 20.9307 4 18.5589 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z"
                  fill="url(#paint0_linear_87_7264)"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 18.5109 2.661 20.8674 3.81847 22.905L2 30L9.31486 28.3038C11.3014 29.3854 13.5789 30 16 30ZM16 27.8462C22.5425 27.8462 27.8462 22.5425 27.8462 16C27.8462 9.45755 22.5425 4.15385 16 4.15385C9.45755 4.15385 4.15385 9.45755 4.15385 16C4.15385 18.5261 4.9445 20.8675 6.29184 22.7902L5.23077 26.7692L9.27993 25.7569C11.1894 27.0746 13.5046 27.8462 16 27.8462Z"
                  fill="white"
                />
                <path
                  d="M12.5 9.49989C12.1672 8.83131 11.6565 8.8905 11.1407 8.8905C10.2188 8.8905 8.78125 9.99478 8.78125 12.05C8.78125 13.7343 9.52345 15.578 12.0244 18.3361C14.438 20.9979 17.6094 22.3748 20.2422 22.3279C22.875 22.2811 23.4167 20.0154 23.4167 19.2503C23.4167 18.9112 23.2062 18.742 23.0613 18.696C22.1641 18.2654 20.5093 17.4631 20.1328 17.3124C19.7563 17.1617 19.5597 17.3656 19.4375 17.4765C19.0961 17.8018 18.4193 18.7608 18.1875 18.9765C17.9558 19.1922 17.6103 19.083 17.4665 19.0015C16.9374 18.7892 15.5029 18.1511 14.3595 17.0426C12.9453 15.6718 12.8623 15.2001 12.5959 14.7803C12.3828 14.4444 12.5392 14.2384 12.6172 14.1483C12.9219 13.7968 13.3426 13.254 13.5313 12.9843C13.7199 12.7145 13.5702 12.305 13.4803 12.05C13.0938 10.953 12.7663 10.0347 12.5 9.49989Z"
                  fill="white"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_87_7264"
                    x1="26.5"
                    y1="7"
                    x2="4"
                    y2="28"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#5BD066" />
                    <stop offset="1" stop-color="#27B43E" />
                  </linearGradient>
                </defs>
              </svg>
            </a>
          </div>
        </div>

        <div class="blogContent__desc">
          <div class="rightbox">
            <BlogDesc :unit="unit" />
          </div>
          <div class="blogtexts" v-html="unit.description"></div>
          <div id="products" v-if="unit.products">
            <h3 v-if="$root.globalData">
              {{ $root.globalData.keys.products_text }}
            </h3>
            <p>
              {{ unit.products }}
            </p>
          </div>
        </div>
      </div>

      <div class="blogContent__leftbox">
        <img
          class="hiddenInMobile"
          id="mainUnitImage"
          :src="unit.image"
          :alt="unit.title"
        />
        <div @click="showLocation = true" id="map" class="location">
          <h4 class="location__title">نمایش بر روی نقشه</h4>
          <img class="locationImage" :src="LocationImage" alt="location" />
        </div>

        <div class="social__blog">
          <span> اشتراک گذاری کنید</span>
          <span class="">
            <a @click="share()">
              <ShareIcon />
            </a>
          </span>
        </div>

        <div class="form">
          <BlogForm />
        </div>
      </div>
    </div>
    <div
      v-if="unit.images != null || unit.images.length"
      id="unitBlogSlider"
      class="BlogSlider"
    >
      <BlogSlider :images="unit.images" class="TopBlogSlider" />
    </div>
    <div
      v-click-outside="hiddenMapOption"
      data-aos="fade-up"
      data-aos-duration="2000"
      v-if="showMapOption"
      id="mapOption"
    >
      <h3 v-if="$root.globalData">
        {{ $root.globalData.keys.routing_map_selection_text }}
      </h3>
      <div id="choseBox">
        <button
          :class="{ activeMap: selectedMap == 'googleMap' }"
          @click="selectedMap = 'googleMap'"
        >
          <img src="@/assets/images/google_map.png" alt="google Map" />
          <h5>Google Map</h5>
        </button>
        <button
          :class="{ activeMap: selectedMap == 'neshan' }"
          @click="selectedMap = 'neshan'"
        >
          <img src="@/assets/images/neshan.png" alt="google Map" />
          <h5>نشان</h5>
        </button>
      </div>
      <button v-if="$root.globalData" @click="setMap()" id="startMap">
        {{ $root.globalData.keys.routing_start }}
      </button>
    </div>
    <div
      v-click-outside="onClickOutsideLoc"
      data-aos="fade-up"
      data-aos-duration="2000"
      class="showModalFooter"
      v-if="showLocation"
    >
      <ul>
        <li
          v-for="(item, index) in unit.addresses"
          :key="index"
          @click="gotoLocation(item)"
          style="color: #0000ffc2"
        >
          <h3>
            {{ item.title }}
          </h3>
          <p>
            <svg
              width="22"
              height="22"
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 432.49 432.49"
              style="enable-background: new 0 0 432.49 432.49"
              xml:space="preserve"
            >
              <g>
                <g>
                  <path
                    style="fill: none"
                    d="M178.568,137.364c0,20.775,16.901,37.677,37.677,37.677s37.677-16.901,37.677-37.677
			c0-20.774-16.901-37.677-37.677-37.677S178.568,116.59,178.568,137.364z"
                  />
                  <path
                    style="fill: none"
                    d="M225.096,370.187c-2.273,2.482-5.484,3.895-8.851,3.895c-3.366,0-6.577-1.413-8.851-3.895
			c-0.99-1.082-18.303-20.045-40.335-47.596l-99.61,34.143l148.482,51.069l149.109-51.108l-99.512-34.227
			C243.449,350.084,226.088,369.103,225.096,370.187z"
                  />
                  <path
                    style="fill: #73d0f4"
                    d="M95.855,144.392c0,52.005,80.011,153.768,120.39,199.706
			c40.379-45.951,120.392-147.736,120.392-199.706C336.636,78.008,282.629,24,216.245,24S95.855,78.008,95.855,144.392z
			 M216.245,75.688c34.009,0,61.677,27.668,61.677,61.677c0,34.009-27.668,61.677-61.677,61.677s-61.677-27.668-61.677-61.677
			C154.568,103.356,182.236,75.688,216.245,75.688z"
                  />
                  <path
                    style="fill: #3d6889"
                    d="M405.897,345.366l-124.755-42.908c3.628-4.769,7.303-9.681,10.987-14.721
			c45.457-62.194,68.507-110.423,68.507-143.346C360.636,64.773,295.862,0,216.245,0S71.855,64.773,71.855,144.392
			c0,32.923,23.05,81.151,68.507,143.346c3.715,5.081,7.42,10.033,11.076,14.837L26.606,345.362
			c-4.848,1.662-8.105,6.22-8.108,11.346c-0.003,5.125,3.251,9.687,8.097,11.354l185.428,63.776
			c1.265,0.434,2.584,0.652,3.902,0.652c1.315,0,2.631-0.216,3.892-0.648l186.069-63.776c4.848-1.661,8.105-6.22,8.108-11.345
			C413.996,351.595,410.743,347.033,405.897,345.366z M336.636,144.392c0,51.97-80.013,153.755-120.392,199.706
			c-40.379-45.938-120.39-147.701-120.39-199.706C95.855,78.008,149.861,24,216.245,24S336.636,78.008,336.636,144.392z
			 M215.932,407.803L67.449,356.733l99.61-34.143c22.032,27.551,39.345,46.514,40.335,47.596c2.274,2.482,5.484,3.895,8.851,3.895
			c3.366,0,6.577-1.413,8.851-3.895c0.992-1.084,18.354-20.103,40.434-47.719l99.512,34.227L215.932,407.803z"
                  />
                  <path
                    style="fill: #3d6889"
                    d="M216.245,199.041c34.009,0,61.677-27.668,61.677-61.677c0-34.009-27.668-61.677-61.677-61.677
			s-61.677,27.668-61.677,61.677C154.568,171.373,182.236,199.041,216.245,199.041z M253.922,137.364
			c0,20.775-16.901,37.677-37.677,37.677s-37.677-16.901-37.677-37.677c0-20.774,16.901-37.677,37.677-37.677
			S253.922,116.59,253.922,137.364z"
                  />
                </g>
              </g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>
            <span>
              {{ item.address }}
            </span>
          </p>
        </li>
      </ul>
    </div>
    <div
      v-click-outside="changeinfoModal"
      data-aos="fade-up"
      class="showModalFooter showInfoModal"
      v-if="showInfoModal && screenSize < 999"
    >
      <section id="content">
        <h3>
          <span> دسترسی به موقعیت مکانی </span>
        </h3>
        <p>
          در بخش تنظیمات دستگاه خود امکان دسترسی به موقعیت مکانی را فراهم کنید
        </p>
        <div id="dButton">
          <button @click="showInfoModal = false" id="accBtn">متوجه شدم</button>
          <router-link
            id="gotoHelp"
            :to="'/helpToAccessLocation?fromUnit=' + $route.params.id"
            >راهنمای فعال سازی</router-link
          >
        </div>
      </section>
    </div>
    <div
      v-click-outside="onClickOutsideP"
      data-aos="fade-up"
      class="showModalFooter"
      v-if="showPhone"
    >
      <ul>
        <li
          v-for="(item, index) in unit.addresses"
          :key="index"
          style="color: #0000ffc2"
        >
          <h3>
            {{ item.title }}
          </h3>
          <p>
            <template v-if="item.mobile">
              <!-- @click="showPhoneOptionFunc(mobile)" -->
              <a
                v-for="mobile in getMobiles(item.mobile)"
                :key="mobile"
                :href="`tel://${mobile}`"
              >
                {{ mobile }}
              </a>
            </template>
            <!-- @click="showPhoneOptionFunc(item.phones)" -->
            <a :href="`tel://${item.phones}`" v-else>
              {{ item.phones }}
            </a>
          </p>
        </li>
      </ul>
    </div>
    <div
      v-click-outside="onClickOutsideoP"
      id="showPhoneOption"
      v-if="showPhoneOption"
    >
      <div id="optionPhone">
        <a
          :href="`https://wa.me/${selectedItemForPhoneOption}`"
          target="_blank"
        >
          <img src="@/assets/images/whatsapp.svg" alt="whats app" />
          <h3 v-if="$root.globalData">
            {{ $root.globalData.keys.whatsapp_text }}
          </h3>
        </a>
        <a :href="`tel://${selectedItemForPhoneOption}`" target="_blank">
          <img src="@/assets/images/phone.svg" alt="phone" />
          <h3 v-if="$root.globalData">
            {{ $root.globalData.keys.mobile_text }}
          </h3>
        </a>
      </div>
    </div>
    <div id="footerUnitMobile">
      <svg
        @click="showPhone = true"
        width="30"
        height="30"
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 53.943 53.943"
        style="enable-background: new 0 0 53.943 53.943"
        xml:space="preserve"
      >
        <g>
          <g>
            <path
              style="fill: #52c306"
              d="M52.48,41.377c-1.898-3.587-8.899-7.69-8.899-7.69c-1.584-0.903-3.495-1.004-4.399,0.606
			c0,0-2.274,2.728-2.853,3.12c-2.643,1.791-5.091,1.722-7.562-0.75l-5.743-5.743l-5.743-5.743c-2.472-2.472-2.541-4.919-0.75-7.562
			c0.392-0.579,3.12-2.853,3.12-2.853c1.609-0.904,1.509-2.815,0.606-4.399c0,0-4.103-7.001-7.69-8.899
			c-1.526-0.808-3.4-0.526-4.621,0.695L5.408,4.694c-8.045,8.045-4.084,17.129,3.961,25.174l7.353,7.353l7.353,7.353
			c8.045,8.045,17.129,12.007,25.174,3.961l2.537-2.537C53.006,44.777,53.288,42.903,52.48,41.377z"
            />
            <path
              style="fill: #388f04"
              d="M39.659,53.942c-1.054,0-2.128-0.127-3.223-0.38c-4.132-0.956-8.529-3.742-13.069-8.282
			L8.662,30.575c-4.54-4.54-7.327-8.938-8.282-13.069C-0.767,12.549,0.687,8,4.7,3.987L7.237,1.45
			c1.541-1.541,3.87-1.891,5.795-0.872c3.795,2.008,7.912,8.98,8.085,9.276c0.734,1.288,0.964,2.61,0.652,3.733
			c-0.234,0.844-0.768,1.531-1.545,1.994c-1.22,1.021-2.646,2.286-2.871,2.596c-1.601,2.363-1.413,4.246,0.632,6.291l11.487,11.486
			c2.045,2.044,3.927,2.232,6.294,0.629c0.307-0.222,1.572-1.647,2.592-2.867c0.463-0.778,1.151-1.312,1.996-1.546
			c1.121-0.309,2.443-0.081,3.721,0.646c0.306,0.18,7.279,4.296,9.287,8.092l0,0c1.02,1.925,0.669,4.254-0.872,5.796l-2.537,2.536
			C46.828,52.369,43.376,53.942,39.659,53.942z M10.721,2.002c-0.757,0-1.503,0.296-2.07,0.862L6.114,5.401
			c-3.542,3.542-4.781,7.354-3.786,11.654c0.87,3.762,3.477,7.834,7.748,12.105l14.705,14.705c4.271,4.271,8.344,6.878,12.105,7.748
			c4.302,0.992,8.113-0.244,11.655-3.787l2.537-2.536c0.916-0.917,1.125-2.302,0.519-3.446l0,0
			c-1.743-3.294-8.453-7.256-8.521-7.296c-0.777-0.442-1.597-0.614-2.186-0.45c-0.36,0.1-0.633,0.323-0.835,0.683l-0.104,0.151
			c-0.711,0.853-2.433,2.883-3.061,3.308c-3.148,2.134-6.119,1.84-8.83-0.871L16.572,25.883c-2.71-2.711-3.003-5.682-0.871-8.83
			c0.426-0.629,2.456-2.35,3.309-3.062l0.151-0.104c0.359-0.202,0.583-0.475,0.683-0.835c0.163-0.588-0.007-1.409-0.457-2.197
			c-0.034-0.057-3.996-6.767-7.29-8.51C11.661,2.114,11.189,2.002,10.721,2.002z"
            />
          </g>
          <path
            style="fill: #52c306"
            d="M29.937,25.005c-0.552,0-1-0.447-1-1v-12c0-0.553,0.448-1,1-1s1,0.447,1,1v12
		C30.937,24.558,30.489,25.005,29.937,25.005z"
          />
          <path
            style="fill: #52c306"
            d="M41.937,25.005h-12c-0.552,0-1-0.447-1-1s0.448-1,1-1h12c0.552,0,1,0.447,1,1
		S42.489,25.005,41.937,25.005z"
          />
          <path
            style="fill: #52c306"
            d="M29.937,25.005c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l17-17
		c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-17,17C30.449,24.907,30.193,25.005,29.937,25.005z"
          />
          <path
            style="fill: #388f04"
            d="M39.673,42.608c-0.034,0-0.069-0.002-0.104-0.005c-6.895-0.716-11.41-5.097-11.599-5.283
		c-0.393-0.387-0.397-1.019-0.011-1.412c0.387-0.394,1.021-0.4,1.414-0.013c0.042,0.04,4.228,4.077,10.402,4.718
		c0.549,0.058,0.949,0.549,0.892,1.099C40.613,42.225,40.179,42.608,39.673,42.608z"
          />
          <path
            style="fill: #388f04"
            d="M17.67,26.608c-0.223,0-0.448-0.075-0.634-0.229c-0.23-0.188-5.637-4.715-6.359-11.668
		c-0.057-0.55,0.342-1.041,0.892-1.099c0.553-0.042,1.041,0.344,1.098,0.892c0.635,6.12,5.592,10.291,5.642,10.332
		c0.425,0.353,0.485,0.982,0.134,1.408C18.244,26.484,17.958,26.608,17.67,26.608z"
          />
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg>
      <a id="routingMap" v-if="$root.globalData" @click="showLocationFunc">
        {{ $root.globalData.keys.routing_text }}</a
      >
    </div>
  </div>

  <loader v-else />
</template>

<script>
import loader from "../components/loader.vue";
import BlogSlider from "../components/main/BlogSlider.vue";
import StarIcon from "../components/svgs/StarIcon.vue";
import BlogDesc from "../components/main/BlogDesc.vue";
import Image from "../assets/images/googlemap.jpg";
import Telegram from "../components/svgs/Telegram.vue";
import Instagram from "../components/svgs/Instagram.vue";
import Whatsapp from "../components/svgs/WhatsappDarkIcon.vue";
import ShareIcon from "../components/svgs/ShareIcon.vue";
import BlogForm from "../components/main/BlogForm.vue";
export default {
  computed: {
    screenSize() {
      return window.innerWidth;
    },
  },
  data() {
    return {
      showInfoModal: false,
      selectedItemForPhoneOption: null,
      showPhoneOption: false,
      selectedMap: "googleMap",
      showMapOption: false,
      showPhone: false,
      showLocation: false,
      unit: null,
      userLocationStatus: false,
      user_latitude: null,
      user_longitude: null,
      LocationImage: Image,
      selectedItemForMap: null,
      Starcount: 5,
      blogTilte: "کارخانه ذوب آهن اصفهان",
    };
  },
  components: {
    loader,
    BlogSlider,
    StarIcon,
    BlogDesc,
    Telegram,
    Instagram,
    ShareIcon,
    BlogForm,
    Whatsapp,
  },

  mounted() {
    if (this.$route.query.fromHelpToAccessLocation) {
      this.$router.replace({ query: null });
      this.$router.go(0);
    }
    this.getLocation();
    this.getUnit();
    this.fnBrowserDetect();
  },
  methods: {
    fnBrowserDetect() {
      let userAgent = navigator.userAgent;
      let browserName;

      if (userAgent.match(/chrome|chromium|crios/i)) {
        browserName = "chrome";
      } else if (userAgent.match(/firefox|fxios/i)) {
        browserName = "firefox";
      } else if (userAgent.match(/safari/i)) {
        browserName = "safari";
      } else if (userAgent.match(/opr\//i)) {
        browserName = "opera";
      } else if (userAgent.match(/edg/i)) {
        browserName = "edge";
      } else {
        browserName = "No browser detection";
      }

      console.log("You are using " + browserName + " browser");
    },
    changeinfoModal() {
      this.showInfoModal = false;
    },
    getUnit() {
      this.$axios
        .get(`front/unit?unitId=${this.$route.params.id}`)
        .then((res) => {
          this.unit = res.data.unit;
        });
    },
    getMobiles(mobiles) {
      return mobiles.split(",");
    },
    onClickOutsideoP() {
      this.showPhoneOption = false;
    },
    showPhoneOptionFunc(item) {
      this.showPhone = false;

      setTimeout(() => {
        this.showPhoneOption = true;
      }, 500);
      this.selectedItemForPhoneOption = item;
    },
    onClickOutsideP() {
      this.showPhone = false;
    },
    onClickOutsideLoc() {
      this.showLocation = false;
    },
    showLocationFunc() {
      this.showLocation = true;
    },
    getMobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        return "other";
      }

      if (/android/i.test(userAgent)) {
        return "Android";
      }

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "Ios";
      }

      return "other";
    },
    gotoLocation(item) {
      if (window.innerWidth > 768) {
        // old
        // window.open(
        //   `https://www.google.com/maps/@${item.latitude},${item.longitude},14z`,
        //   "_blank"
        // );
        // new
        window.open(
          `https://maps.neshan.org/@${item.latitude},${item.longitude},14z`,
          "_blank"
        );
      } else {
        this.showLocation = false;

        this.selectedItemForMap = item;
        setTimeout(() => {
          this.showMapOption = true;
        }, 500);
      }
    },
    setMap() {
      let item = this.selectedItemForMap;
      //  return this.$router.push(`/redirect?mapType=${this.selectedMap == "neshan"?'neshan':'googleMap'}&deviceIo=${this.getMobileOperatingSystem()}&latitude=${item.latitude}&longitude=${item.longitude}`)

      if (this.selectedMap == "neshan") {
        if (this.getMobileOperatingSystem() != "other") {
          if (this.getMobileOperatingSystem() == "ios") {
            window.open(
              "neshan://?ll=" + `${item.latitude},${item.longitude}`,
              "_blank"
            );
          } else {
            window.open(`nshn:${item.latitude},${item.longitude}`, "_blank");
          }
        } else {
          window.open(
            `https://www.google.com/maps/@${item.latitude},${item.longitude},14z`,
            "_blank"
          );
        }
      } else {
        if (this.userLocationStatus == false) {
          this.$toast.warning(
            this.$root.globalData
              ? this.$root.globalData.keys.your_location_could_not_be_found
              : ""
          );
        } else {
          window.open(
            `https://www.google.com/maps/dir/?api=1&origin=${this.user_latitude},${this.user_longitude}&destination=${item.latitude},${item.longitude}`,
            "_blank"
          );
        }
      }
    },
    setMap1() {
      let item = this.selectedItemForMap;
      //  return this.$router.push(`/redirect?mapType=${this.selectedMap == "neshan"?'neshan':'googleMap'}&deviceIo=${this.getMobileOperatingSystem()}&latitude=${item.latitude}&longitude=${item.longitude}`)

      if (this.userLocationStatus == false) {
        this.$toast.warning(
          this.$root.globalData
            ? this.$root.globalData.keys.your_location_could_not_be_found
            : ""
        );
      } else {
        if (this.selectedMap == "neshan") {
          if (this.getMobileOperatingSystem() != "other") {
            if (this.getMobileOperatingSystem() == "ios") {
              window.open(
                "neshan://?ll=" + `${item.latitude},${item.longitude}`,
                "_blank"
              );
            } else {
              window.open(`nshn:${item.latitude},${item.longitude}`, "_blank");
            }
          } else {
            window.open(
              `https://www.google.com/maps/@${item.latitude},${item.longitude},14z`,
              "_blank"
            );
          }
        } else {
          window.open(
            `https://www.google.com/maps/dir/?api=1&origin=${this.user_latitude},${this.user_longitude}&destination=${item.latitude},${item.longitude}`,
            "_blank"
          );
        }
      }
    },
    share() {
      if (navigator.share) {
        navigator
          .share({
            title: this.unit.title,
            text:
              this.$cookie.get("language") == "en"
                ? "An excellent industrial unit"
                : "یک واحد صنعتی عالی",
            url: "https://" + window.location.host + "/unit/" + this.unit.id,
          })
          .then(() => {})
          .catch((error) => console.error(error));
      }
    },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    getLocation() {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          this.showPosition,
          this.showError,
          {
            timeout: 5000,
            enableHighAccuracy: true,
          }
        );
      } else {
        setTimeout(() => {
          this.getLocation();
        }, 1000);
      }
    },
    hiddenMapOption() {
      this.showMapOption = false;
    },
    showPosition(position) {
      if (!position) return;
      this.user_latitude = position.coords.latitude;
      this.user_longitude = position.coords.longitude;
      this.userLocationStatus = true;
      this.getUnit();
    },

    showError(error, option) {
      console.log(error);
      this.userLocationStatus = false;
      this.showInfoModal = true;
    },
  },

  metaInfo() {
    return {
      title: this.unit ? this.unit.title : "واحد صنعتی",
      meta: [
        { name: "description", content: "واحد صنعتی" },
        { property: "og:title", content: "واحد صنعتی" },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
};
</script>

<style scoped>
div#socialUnit {
  display: flex;
  align-items: center;
}
.blog {
  background-color: #e3e3e3;
  text-align: right;
}

.BlogContent {
  display: grid;
  grid-template-columns: auto 300px;
  padding: 3rem 0;
  direction: rtl;
}

.blogbox__title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid #ccc;
  padding: 10px 0;
  margin-bottom: 1rem;
}

.blogContent__leftbox {
  text-align: right;
  padding: 0 10px;
}
.location {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  color: #000;
  text-align: right;
}
.location__title {
  margin-bottom: 1rem;
}
.locationImage {
  border-radius: 10px;
  width: 100%;
}

.social__blog {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  width: 90%;
  margin: auto;
}

.social__blog span {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.socialIcon svg {
  fill: #000;
}
#footerUnitMobile {
  display: none;
}
@media only screen and (max-width: 768px) {
  .BlogContent {
    grid-template-columns: 1fr;
    padding: 0 0 3rem;
  }
  #footerUnitMobile {
    display: flex;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 15px;
    justify-content: space-between;
    background: white;
    z-index: 100;
    box-shadow: 0 0 10px #00000069;
  }
  .TopBlogSlider swiper-slide img {
    width: 100%;
  }
}
div#mapOption {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 10000;
  border-top-right-radius: 60px;
  border-top-left-radius: 60px;
  box-shadow: 0 0 10px #00000061;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  height: max-content;
  background: white;
  padding: 15px;
}
div#choseBox img {
  width: 100%;
}
div#choseBox {
  display: flex;
  gap: 15px;
  height: 100px;
}
div#choseBox button {
  width: 60px;
  height: 60px;
  cursor: pointer;
  padding: 5px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
div#choseBox button h5 {
  width: max-content;
}
button.activeMap {
  border-bottom: 3px solid red;
  transform: scale(1.2);
}
#startMap {
  background: #438ffd;
  color: white;
  padding: 10px;
  border-radius: 5px;
}
div#socialUnit svg {
  width: 50px;
  height: 50px;
}
@media (max-width: 580px) {
  div#socialUnit svg {
    width: 35px;
    height: 35px;
  }
}
</style>
<style>
.ol-overlaycontainer-stopevent {
  display: none;
}
.showModalFooter {
  position: fixed;
  z-index: 1000;
  background: white;
  padding: 20px;
  width: 20%;
  margin-right: 10%;
  left: 9%;
  border-radius: 15px;
  box-shadow: 0 0 10px #09010182;
  min-height: 300px;
  bottom: 40px;
}
@media (max-width: 768px) {
  #unitBlogSlider .slick-prev {
    left: 0 !important;
    z-index: 100;
  }
  #unitBlogSlider .slick-next {
    right: 0 !important;
    z-index: 100;
  }
  .showModalFooter {
    position: fixed;
    z-index: 1000;
    background: white;
    padding: 20px;
    width: 80%;
    margin-right: 10%;
    left: 10%;
    border-radius: 15px;
    box-shadow: 0 0 10px #09010182;
    min-height: 300px;
    bottom: 100px;
  }
}
.showModalFooter ul li {
  margin-bottom: 10px;
}
/* div#map {
    padding: 10px;
    background: white;
    border-radius: 10px;
    height: 250px;
} */
#routingMap {
  background-color: #3d8bfd;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 14px;
}
div#footerUnitMobile svg path {
  fill: #3d8bfd !important;
}
.showModalFooter ul li span {
  font-weight: bold;
}
.showModalFooter ul li p span {
  font-size: 14px;
}
.showModalFooter ul li p {
  display: flex;
  justify-content: space-between;
  direction: rtl;
}
.showModalFooter ul li h3 {
  color: #000000c4;
  margin-bottom: 10px;
}
.hiddenInDesktop {
  display: none;
}
@media (max-width: 768px) {
  .hiddenInMobile {
    display: none;
  }
  .hiddenInDesktop {
    display: block;
  }
}
img#mainUnitImage {
  width: 100%;
}
.showInfoModal {
  min-height: 200px;
}
img#mobile_unitMainImage {
  width: 100%;
  padding: 15px 0;
}
img#mobile_unitMainImage {
  width: 100%;
  padding: 15px 0;
}

div#showPhoneOption {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100000000;
  background: white;
  width: 100%;
  padding: 10px;

  border-top-right-radius: 60px;
  border-top-left-radius: 60px;
}
div#optionPhone h3 {
  color: black;
  font-size: 15px;
}
div#optionPhone a {
}
div#optionPhone a img {
  width: 50px;
  height: 50px;
}
div#optionPhone {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
}
div#products p {
  white-space: pre-wrap;
  margin: 15px;
  font-size: 18px;
  font-family: "IRANSans";
}
div#products h3 {
  color: #3d8bfd;
}
button#accBtn {
  background-color: green;
  padding: 12px 8px;
  border-radius: 10px;
  color: white;
  font-size: smaller;
}
#gotoHelp {
  background-color: blue;
  padding: 12px;
  border-radius: 10px;
  color: white;
  font-size: 13px;
}
#dButton {
  display: flex;
  width: 98%;
  margin: auto;
  justify-content: space-between;
}
</style>
